module.exports = __webpack_public_path__ + "img/Rider_icon.28a1e9bd.png";